import { INode } from "../types/INode"
import { Node } from "../types/Node"
import { Finder, IFinder } from "../finder/IFinder"
import { DateString } from "@/DateString"
export class Dict {

    grupy_maszyn: any[] = [ 'A','G','R','H' ]

    maszyny: any[] = [
        { nazwa_maszyny: "",  nazwa_maszyny_dla_iml: "",  nr_maszyny: 0, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "ARSOMA_1",  nazwa_maszyny_dla_iml: "ARSOMA_1",  nr_maszyny: 1, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "ARSOMA_2",  nazwa_maszyny_dla_iml: "ARSOMA_2",  nr_maszyny: 2, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "ARSOMA_3",  nazwa_maszyny_dla_iml: "ARSOMA_3",  nr_maszyny: 3, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "ARSOMA_4",  nazwa_maszyny_dla_iml: "ARSOMA_4",  nr_maszyny: 4, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "ARSOMA_5",  nazwa_maszyny_dla_iml: "ARSOMA_5",  nr_maszyny: 5, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "ARSOMA_6",  nazwa_maszyny_dla_iml: "ARSOMA_6",  nr_maszyny: 6, nr_maszyny_dla_iml: 26},
        { nazwa_maszyny: "ARSOMA_7",  nazwa_maszyny_dla_iml: "ARSOMA_7",  nr_maszyny: 7, nr_maszyny_dla_iml: 27},
        { nazwa_maszyny: "RCS_1",  nazwa_maszyny_dla_iml: "RCS_1",  nr_maszyny: 8, nr_maszyny_dla_iml: 28},
        { nazwa_maszyny: "RCS_2",  nazwa_maszyny_dla_iml: "RCS_2",  nr_maszyny: 9, nr_maszyny_dla_iml: 29},
        { nazwa_maszyny: "ECS_10",  nazwa_maszyny_dla_iml: "ECS 10",  nr_maszyny: 10, nr_maszyny_dla_iml: 30},
        { nazwa_maszyny: "ARSOMA_6",  nazwa_maszyny_dla_iml: "IML DRUK NA ARSOMA_6",  nr_maszyny: 26, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "ARSOMA_7",  nazwa_maszyny_dla_iml: "IML DRUK NA ARSOMA_7",  nr_maszyny: 27, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "RCS_1",  nazwa_maszyny_dla_iml: "IML DRUK NA RCS_1",  nr_maszyny: 28, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "RCS_2",  nazwa_maszyny_dla_iml: "IML DRUK NA RCS_2",  nr_maszyny: 29, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "SITODRUK_ARKUSZE",  nazwa_maszyny_dla_iml: "SITODRUK_ARKUSZE",  nr_maszyny: 91, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "TYPO",  nazwa_maszyny_dla_iml: "TYPO",  nr_maszyny: 92, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "OFFSET_ARKUSZE",  nazwa_maszyny_dla_iml: "OFFSET_ARKUSZE",  nr_maszyny: 93, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "SZTANCERKA",  nazwa_maszyny_dla_iml: "SZTANCERKA",  nr_maszyny: 50, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "ECS 10",  nazwa_maszyny_dla_iml: "IML DRUK NA ECS 10",  nr_maszyny: 30, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "RCS_3",  nazwa_maszyny_dla_iml: "RCS_3",  nr_maszyny: 11, nr_maszyny_dla_iml: 31},
        { nazwa_maszyny: "RCS_3",  nazwa_maszyny_dla_iml: "IML DRUK NA RCS_3",  nr_maszyny: 31, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "GIDUE_12",  nazwa_maszyny_dla_iml: "GIDUE_12",  nr_maszyny: 12, nr_maszyny_dla_iml: 32},
        { nazwa_maszyny: "GIDUE_12",  nazwa_maszyny_dla_iml: "IML DRUK NA GIDUE_12",  nr_maszyny: 32, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "RCS_4",  nazwa_maszyny_dla_iml: "RCS_4",  nr_maszyny: 13, nr_maszyny_dla_iml: 33},
        { nazwa_maszyny: "RCS_4",  nazwa_maszyny_dla_iml: "IML DRUK NA RCS_4",  nr_maszyny: 33, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "GIDUE_2",  nazwa_maszyny_dla_iml: "GIDUE_2",  nr_maszyny: 14, nr_maszyny_dla_iml: 34},
        { nazwa_maszyny: "RCS_5",  nazwa_maszyny_dla_iml: "RCS_5",  nr_maszyny: 15, nr_maszyny_dla_iml: 35},
        { nazwa_maszyny: "GIDUE_2",  nazwa_maszyny_dla_iml: "IML DRUK NA GIDUE_2",  nr_maszyny: 34, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "RCS_5",  nazwa_maszyny_dla_iml: "IML DRUK NA RCS_5",  nr_maszyny: 35, nr_maszyny_dla_iml: 0},
        { nazwa_maszyny: "HP_1",  nazwa_maszyny_dla_iml: "HP_1",  nr_maszyny: 16, nr_maszyny_dla_iml: 36},
        { nazwa_maszyny: "HP_1",  nazwa_maszyny_dla_iml: "IML DRUK NA HP_1",  nr_maszyny: 36, nr_maszyny_dla_iml: 0},
    ]

    przewijarki: any[] = [
        { nr_maszyny: 1, nazwa_maszyny: "ROTO_FLEX_2_VSI330"},
        { nr_maszyny: 2, nazwa_maszyny: "ROTO_FLEX_1_VSI_250"},
        { nr_maszyny: 3, nazwa_maszyny: "JURMET_1"},
        { nr_maszyny: 4, nazwa_maszyny: "JURMET_2"},
        { nr_maszyny: 5, nazwa_maszyny: "LEOMAT_2"},
        { nr_maszyny: 6, nazwa_maszyny: "LESKO_RLS"},
        { nr_maszyny: 7, nazwa_maszyny: "LESKO_1"},
        { nr_maszyny: 8, nazwa_maszyny: "LESKO_2"},
        { nr_maszyny: 9, nazwa_maszyny: "LESKO_3"},
        { nr_maszyny: 10, nazwa_maszyny: "GANNICOTT"},
        { nr_maszyny: 11, nazwa_maszyny: "RIETSTACK"},
        { nr_maszyny: 12, nazwa_maszyny: "LESKO_4"},
        { nr_maszyny: 13, nazwa_maszyny: "SZTANCERKA_LEOMAT"},
        { nr_maszyny: 14, nazwa_maszyny: "WYKLEJARKA_1"},
        { nr_maszyny: 15, nazwa_maszyny: "WYKLEJARKA_2"},
        { nr_maszyny: 16, nazwa_maszyny: "WYKLEJARKA_3"},
        { nr_maszyny: 17, nazwa_maszyny: "JURMET_3"},
        { nr_maszyny: 18, nazwa_maszyny: "LESKO_5"},
    ]

    rodzaje:string[] = ["MASZYNY DRUKUJĄCE", "PRZEWIJARKI", "NARZĘDZIA", "INFRASTRUKTURA IT", "BUDYNKI", "INSTALACJE", "MEBLE"] 
    lokalizacje:string[] = ["HALA 1", "HALA 2", "HALA 3", "PRZYGOTOWALNIA", "SEKRETARIAT",] 
}

export interface IDevice extends INode {
    type:string;
    version:number;
    _id:string|undefined
    parent_id:string
    _err:any;
    fnd:string;
    del:number;


    idn:string;
    nr_maszyny: Number;

    rodzaj: string; // deviceTypes
    lokalizacja:string;

    status:string;
    in_use_by:string|undefined;
    counter_MAC:string|undefined;
    
    dist1_MAC:string|undefined;
    dist1_base:number;

    counter_faktor:number;
    counter_base:number;
}
  
export class Device implements IDevice {
    type:string="device";
    version:number=0;
    _id:string|undefined = undefined;
    parent_id:string=""
    idn:string =  "URZĄDZENIE_"+DateString.toISOString()
    fnd:string=""
    del:number=0

    nr_maszyny: Number=0;
  
    rodzaj: string=""; // deviceTypes
    lokalizacja:string="";

    status:string="OK";
    in_use_by:string|undefined=undefined;
    counter_MAC:string|undefined;
    dist1_MAC:string|undefined;
    dist1_base:number=0;
    _err:any={}
    counter_faktor:number=1.0;
    counter_base:number=0.0;
}

